import UseGoogleReview from './useGoogleReview';
import UseGoogleReviewSuggestedProducts from './useGoogleReviewSuggestedProducts';

export default {
  UseGoogleReview,
  UseGoogleReviewSuggestedProducts,
};
